import React from "react";
import {
  TextField,
  FormControl,
  FormLabel,
  Button,
  Grid,
  Box,
  Typography,
  FormHelperText,
} from "@mui/material";
import UploadCloudIcon from "../assets/component-icon/UploadCloudIcon";
import VisibilityIcon from '@mui/icons-material/Visibility';

import checkIcon from "../assets/icons/check-green.svg";
import { UPLOAD_FILE_TYPES } from "../config/constant";

const UploadInput = ({ field, formik, paymentProof=false, index,twoImages=false, disabled=false,fileType='PDF',showFileSupportedMessage=false,fileSize,showCheckMark=false,textfieldReadonly=true }) => {
 
  
const hasValidUpload = (val, twoImages = false) => {
  if (!val) return false;

  // Single value case (string or object)
  if (!Array.isArray(val)) {
    return !!val;
  }

  // Two images case → check if first or second slot has valid value
  if (twoImages) {
    return !!(val[0] && val[0].length > 0) || !!(val[1] && val[1].length > 0);
  }

  // Generic array case → return true if at least one non-empty string/object exists
  return val.some((item) => {
    if (Array.isArray(item)) return item.length > 0; // nested array
    if (typeof item === "string") return item.trim() !== "";
    return !!item;
  });
};



const value = paymentProof ? formik?.values?.transactions[index]?.[field?.name] :formik?.values?.[field?.name] 
const uploaded = hasValidUpload(value, twoImages);

  return (
    <FormControl sx={{ width: "100%" }}>
      {field?.label && (
        <FormLabel
          className="form-label"
          htmlFor={field?.name}
          sx={{
            color: "#1C252E",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "22px",
            mb: "6px",
          }}
        >
          {field?.label}
          {field?.required && <span className="asteriskColor"> *</span>}
        </FormLabel>
      )}
      <Grid container sx={{ width: "100%" }}>
        <Grid item xs={12} sx={{ width: "100%" }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                position: "relative",
              }}
            >
              {paymentProof ?
              <>
              <Typography
                sx={{
                  width: "17px",
                  height: "17px",
                  position: "absolute",
                  top: "12px",
                  right: "12px",
                  zIndex: "5",
                }}
              >
                {uploaded && (
                  <img src={checkIcon} alt="" />
                )}
              </Typography>
              <TextField
                sx={{
                  //width: "60%",
                  width: "100%",
                  padding: "0",
                  border: "0",
                  // marginTop: `${field?.label ? "" : "6%"}`,
                  "& .MuiOutlinedInput-root": {
                    height: "44px",
                    padding: "10px 14px 10px 0px",
                    borderRadius: "8px",
                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    fontSize: "14px",
                    fontWeight: "400",
                  },
                  "& .MuiInputBase-input": {
                    height: "100%", // Ensure input field spans full height
                    cursor: "pointer",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color:
                      field?.physicalCopyValue ||
                      formik?.values?.transactions[index]?.[field?.name]?.length > 0
                        ? "#808080"
                        : "",
                    opacity:
                      field?.physicalCopyValue ||
                      formik?.values?.transactions[index]?.[field?.name]?.length > 0
                        ? "5"
                        : "",
                  },
                }}
                //fullWidth
                id={field?.name}
                name={field?.name}
                placeholder={
                      uploaded
                    ? field?.placeholderUpload
                    : field?.placeholder
                }
                type={field?.type || "text"}
                inputProps={{ maxLength: 50 }}
                // value={
                //   field?.value ? field?.value : formik?.values?.[field?.name]
                // }
                // onChange={(e) => {
                //   field?.handleOnChange
                //     ? field?.handleOnChange(e, field?.index, field?.name, null)
                //     : formik?.handleChange(e);
                // }}
                // onBlur={formik?.handleBlur}
                // error={
                //   formik?.touched?.[field?.name] &&
                //   Boolean(formik?.errors?.[field?.name])
                // }
                error={
                  field?.listKey
                    ? formik?.touched?.[field?.listKey]?.[field?.index]?.[
                        field?.nameKey
                      ] &&
                      Boolean(
                        formik?.errors?.[field?.listKey]?.[field?.index]?.[
                          field?.nameKey
                        ]
                      )
                    : formik?.touched?.[field?.name] &&
                      Boolean(formik?.errors?.[field?.name])
                }
                helperText={
                  field?.listKey
                    ? formik?.touched?.[field?.listKey]?.[field?.index]?.[
                        field?.nameKey
                      ] &&
                      formik?.errors?.[field?.listKey]?.[field?.index]?.[field?.nameKey]
                    : formik?.touched?.[field?.name] && formik?.errors?.[field?.name]
                }
                InputProps={{ readOnly: true }}
                variant="outlined"
                onClick={() => {
                  field?.handleOnClick();
                }}

                // disabled={true}
              />
              </>
              :
              <>
              <Typography
                sx={{
                  width: "17px",
                  height: "17px",
                  position: "absolute",
                  top: "12px",
                  right: "12px",
                  zIndex: "5",
                }}
              >
                {(uploaded|| showCheckMark) && textfieldReadonly && (
                  <img src={checkIcon} alt="" />
                )}
              </Typography>
              {textfieldReadonly ?<TextField
              disabled={disabled}
                sx={{
                  //width: "60%",
                  width: "100%",
                  padding: "0",
                  border: "0",
                  // marginTop: `${field?.label ? "" : "6%"}`,
                  "& .MuiOutlinedInput-root": {
                    height: "44px",
                    padding: "10px 14px 10px 0px",
                    borderRadius: "8px",
                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    fontSize: "14px",
                    fontWeight: "400",
                  },
                  "& .MuiInputBase-input": {
                    height: "100%", // Ensure input field spans full height
                    cursor: "pointer",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color:
                      field?.physicalCopyValue ||
                      formik?.values?.[field?.name]?.length > 0
                        ? "#808080"
                        : "",
                    opacity:
                      field?.physicalCopyValue ||
                      formik?.values?.[field?.name]?.length > 0
                        ? "5"
                        : "",
                  },
                }}
                //fullWidth
                id={field?.name}
                name={field?.name}
                placeholder={
                  uploaded
                    ? field?.placeholderUpload
                    : field?.placeholder
                }
                type={field?.type || "text"}
                inputProps={{ maxLength: 50 }}
                // value={
                //   field?.value ? field?.value : formik?.values?.[field?.name]
                // }
                // onChange={(e) => {
                //   field?.handleOnChange
                //     ? field?.handleOnChange(e, field?.index, field?.name, null)
                //     : formik?.handleChange(e);
                // }}
                // onBlur={formik?.handleBlur}
                // error={
                //   formik?.touched?.[field?.name] &&
                //   Boolean(formik?.errors?.[field?.name])
                // }
                error={
                  field?.listKey
                    ? formik?.touched?.[field?.listKey]?.[field?.index]?.[
                        field?.nameKey
                      ] &&
                      Boolean(
                        formik?.errors?.[field?.listKey]?.[field?.index]?.[
                          field?.nameKey
                        ]
                      )
                    : formik?.touched?.[field?.name] &&
                      Boolean(formik?.errors?.[field?.name])
                }
                helperText={
                  field?.listKey
                    ? formik?.touched?.[field?.listKey]?.[field?.index]?.[
                        field?.nameKey
                      ] &&
                      formik?.errors?.[field?.listKey]?.[field?.index]?.[field?.nameKey]
                    : formik?.touched?.[field?.name] && formik?.errors?.[field?.name]
                }
                InputProps={{ readOnly: true }}
                variant="outlined"
                onClick={() => {
                  if(disabled) return;
                  field?.handleOnClick();
                }}

                // disabled={true}
              /> :
                  <TextField
                      sx={{
                        //width: "60%",
                        width: "100%",
                        padding: "0",
                        border: "0",
                        // marginTop: `${field?.label ? "" : "6%"}`,
                        "& .MuiOutlinedInput-root": {
                          height: "44px",
                          padding: "10px 14px 10px 0px",
                          borderRadius: "8px",
                          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                          fontSize: "14px",
                          fontWeight: "400",
                        },
                        "& .MuiInputBase-input": {
                          height: "100%", // Ensure input field spans full height
                          cursor: "pointer",
                        },
                        "& .MuiFormHelperText-root.Mui-error": {
                          color: "#ff0000",
                        },
                        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#ff0000",
                        },
                      }}
                      fullWidth
                      id={field?.inputValueFieldName}
                      name={field?.inputValueFieldName}
                      placeholder={field?.editabletextFieldPlaceholder}
                      type="text"
                      inputProps={{ maxLength: 50 }}
                      value={formik?.values[field?.inputValueFieldName]}
                      onChange={(e) => {
                        field?.handleOnChange(e, field?.name);
                      }}
                      // onBlur={formik?.handleBlur}
                      error={
                        formik?.touched?.[field?.inputValueFieldName] &&
                        Boolean(formik?.errors?.[field?.inputValueFieldName])
                      }
                      helperText={
                        formik?.touched?.[field?.inputValueFieldName] &&
                        formik?.errors?.[field?.inputValueFieldName]
                      }
                      InputProps={{
                        readOnly: false,
                      }}
                      variant="outlined"
                    />}
          
              </>
              }
            </Box>

            {paymentProof ? (
              <Button
                // endIcon={<NavigateNextIcon />}
                // type="submit"
                startIcon={
                  uploaded ? (
                    <VisibilityIcon sx={{ color: "#1A407D" }} />
                  ) : (
                    <UploadCloudIcon disabled={disabled} />
                  )
                }
                sx={{
                  // width: "35%",
                  width: "130px",
                  height: "44px",
                  borderRadius: "8px",
                  background: uploaded ? "none" : "#1A407D",
                  color: uploaded ? "#1A407D" : "#fff",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textTransform: "capitalize",
                  paddingLeft: "26px",
                  paddingRight: "26px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: uploaded ? "1px solid #1A407D" : "none",
                  "&:hover": {
                    backgroundColor: uploaded ? "none" : "#092552",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#E0E0E0", // ✅ Disabled background
                    color: "#9E9E9E", // Optional: make text gray when disabled
                    cursor: "not-allowed", // Optional: show disabled cursor
                    boxShadow: "none", // Optional: remove hover shadows
                  },
                }}
                onClick={() => {
                  field?.handleOnClick();
                }}
                disabled={!uploaded && disabled}
              >
                {uploaded ? "View" : "Upload"}
              </Button>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Button
                  // endIcon={<NavigateNextIcon />}
                  // type="submit"
                  disabled={disabled}
                  startIcon={
                    uploaded && !disabled ? (
                      <VisibilityIcon
                        sx={{ color: disabled ? "grey" : "#1A407D" }}
                      />
                    ) : (
                      <UploadCloudIcon disabled={disabled} />
                    )
                  }
                  sx={{
                    // width: "35%",
                    width: "130px",
                    height: "44px",
                    borderRadius: "8px",
                    background: uploaded ? "none" : "#1A407D",
                    color: uploaded ? "#1A407D" : "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    paddingLeft: "26px",
                    paddingRight: "26px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: uploaded ? "1px solid #1A407D" : "none",
                    "&:hover": {
                      backgroundColor: uploaded ? "none" : "#092552",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#E0E0E0", // ✅ grey background
                      color: "#9E9E9E", // ✅ grey text
                      border: "none", // ✅ optional: remove border when disabled
                    },
                  }}
                  onClick={() => {
                    field?.handleOnClick();
                  }}
                >
                  {uploaded ? "View" : "Upload"}
                </Button>
                {!textfieldReadonly && (
                  <FormHelperText
                    sx={{ color: "red", padding: "0", margin: 0 }}
                  >
                    {field?.listKey
                      ? formik?.touched?.[field?.listKey]?.[field?.index]?.[
                          field?.nameKey
                        ] &&
                        formik?.errors?.[field?.listKey]?.[field?.index]?.[
                          field?.nameKey
                        ]
                      : formik?.touched?.[field?.name] &&
                        formik?.errors?.[field?.name]}
                  </FormHelperText>
                )}
              </Box>
            )}
           
          </Box>
        </Grid>
      </Grid>
      {showFileSupportedMessage && (
        <Typography
          sx={{
            fontSize: "12px",
            color: "rgba(99, 115, 129, 1)",
            marginTop: field?.listKey
                    ? formik?.touched?.[field?.listKey]?.[field?.index]?.[
                        field?.nameKey
                      ] &&
                      formik?.errors?.[field?.listKey]?.[field?.index]?.[field?.nameKey]
                    : formik?.touched?.[field?.name] && formik?.errors?.[field?.name] ? "0px" :'5px',
            marginLeft: "14px",
          }}
        >
          {`File Supported: ${UPLOAD_FILE_TYPES[fileType]} (File size: Maximun ${fileSize} MB)`}
        </Typography>
      )}
    </FormControl>
  );
};

export default UploadInput;
